import { useQuery } from '@tanstack/react-query';
import { fetchPolicyQuestions } from '../api';
import { mapQaSections } from '../utils';

export const getQueryKey = (policyId: number) => {
  return ['policy-questions', policyId];
};

const useQaSections = (policyId: number, enabled = true) => {
  const { isLoading, data } = useQuery({
    queryKey: getQueryKey(policyId),
    queryFn: () => fetchPolicyQuestions(policyId),
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    qaSections: data ? mapQaSections(data) : [],
    isLoading: enabled ? isLoading : false,
  };
};

export default useQaSections;
